// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1nR6v","overflowing":"ReadFullNote_overflowing__2jZes"};